module.exports = __webpack_public_path__ + "img/case1-5.2e498133.jpg";